import { useEffect } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useGetSpace, useGetSubSpaces } from '@onesource/services';
import { SpaceType } from '@onesource/schemas';
import { SpaceHomePage } from '../../../../../features/community-hub/components/space-home-page';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';

export const Route = createFileRoute('/_protected/community-hub/spaces/$id/')({
  component: SpaceHomeRoute,
});

function SpaceHomeRoute() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  const { data: space, isLoading: isLoadingSpace, error: spaceError } = useGetSpace(id);
  const { data: subSpaces, isLoading: isLoadingSubSpaces } = useGetSubSpaces(id);

  const isSingleLesson = space?.spaceType === SpaceType.SINGLE_LESSON;

  useEffect(() => {
    if (isSingleLesson) {
      navigate({ to: `/community-hub/spaces/${id}/lesson`, replace: true });
    }
  }, [isSingleLesson, id, navigate]);

  const modules = subSpaces?.filter(s => s.spaceType === SpaceType.CONTENT) || [];

  if (isLoadingSpace || isLoadingSubSpaces || isSingleLesson) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="300px">
        <CircularProgress />
      </Box>
    );
  }

  if (spaceError) {
    return <Alert severity="error">Failed to load space: {spaceError.message}</Alert>;
  }

  if (!space) {
    return <Alert severity="error">Space not found</Alert>;
  }

  return <SpaceHomePage space={space} modules={modules} />;
}
